// 日志管理API
import request from '@/utils/request'
/**
 * 根据查询条件分页查询登录日志记录
 * @param params
 * @param data
 * @returns {*}
 */
export function logLoginPage(params,data){
    return request({
        url: '/login/log',
        method: 'post',
        data,
        params
    })
}

/**
 * 根据多个日志id，删除多个登录日志记录
 * @param logIds
 * @returns {*}
 */
export function logLoginRemove(logIds) {
    return request({
        url: '/login/log/remove/'+logIds,
        method: 'delete'
    })
}
/**
 * 根据查询条件分页查询日志记录
 * @param params
 * @param data
 * @returns {*}
 */
export function logPage(params,data){
    return request({
        url: '/oper/log',
        method: 'post',
        data,
        params
    })
}

/**
 * 根据多个日志id，删除多个日志记录
 * @param logIds
 * @returns {*}
 */
export function logRemove(logIds) {
    return request({
        url: '/oper/log/remove/'+logIds,
        method: 'delete'
    })
}
export function logGet(operId) {
    return request({
        url: '/oper/log/'+operId,
        method: 'get'
    })
}
